import { Select } from './ui/select';

interface Category {
  _id: string;
  name: string;
}

interface CategorySelectProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  categories: Category[];
  onAddNew?: () => void;
  placeholder?: string;
  disabled?: boolean;
  showAddOption?: boolean;
  className?: string;
}

/**
 * Category select component with inline creation option
 * @param {CategorySelectProps} props - Component props
 * @returns {JSX.Element} Category select component
 */
export function CategorySelect({
  id,
  value,
  onChange,
  categories,
  onAddNew,
  placeholder = "Select a category",
  disabled = false,
  showAddOption = true,
  className = ""
}: CategorySelectProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    
    if (selectedValue === '__add_new__' && onAddNew) {
      onAddNew();
    } else {
      onChange(selectedValue);
    }
  };

  return (
    <Select
      id={id}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className={`w-full ${className}`}
    >
      <option value="">{placeholder}</option>
      
      {/* Add new option at the top if enabled */}
      {showAddOption && onAddNew && (
        <option 
          value="__add_new__" 
          className="font-medium text-primary border-b"
        >
          ➕ Add new {placeholder.toLowerCase().includes('subcategory') ? 'subcategory' : 'category'}
        </option>
      )}
      
      {/* Existing categories */}
      {categories.map(cat => (
        <option key={cat._id} value={cat._id}>
          {cat.name}
        </option>
      ))}
    </Select>
  );
}